import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import {
  hideLoadingBox,
  showLoadingBox,
  showMessageBox,
} from '../../../../store/actions/system.actions'
import { useEffect, useRef, useState } from 'react'
import useRelatorioInventarioPosicao, { LOAD_MESSAGE } from './RelatorioInventarioPosicaoHook'
import {
  CustomCard,
  CustomCheckbox,
  CustomDataTableHeader,
  CustomDropdown,
  CustomPanel,
  PageHeader,
  Periodo,
} from '../../../../components'
import React from 'react'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { tableCellCentered } from '../../../../assets/js/styles'
import { Button } from 'primereact/button'
import { Dropdown } from 'primereact/dropdown'

function RelatorioInventarioPosicao({ dispatch, history, selectedTp }) {
  const { state, localDispatch } = useRelatorioInventarioPosicao()
  const [selectedStatus, setSelectedStatus] = useState(null)

  const onStatusChange = event => {
    dt.current.filter(event.value, 'status', 'equals')
    setSelectedStatus(event.value)
  }

  const status = [
    { label: 'Aberto', value: 'Aberto' },
    { label: 'Em Conferencia', value: 'Em Conferência' },
    { label: 'Finalizado', value: 'Finalizado' },
  ]

  const statusFilter = (
    <Dropdown
      style={{ width: '100%' }}
      placeholder="Selecione um Status"
      value={selectedStatus}
      options={status}
      onChange={onStatusChange}
      showClear
    />
  )

  let dt = useRef(null)

  const onExport = () => {
    dt.current.exportCSV()
  }

  useEffect(() => {
    localDispatch.onInit(selectedTp)
  }, [selectedTp])

  useEffect(() => {
    switch (state.loadingMessage) {
      case LOAD_MESSAGE.NONE:
        dispatch(hideLoadingBox())
        break

      case LOAD_MESSAGE.PRODUTOS:
        dispatch(showLoadingBox('Aguarde...', state.loadingMessage))
        localDispatch.getProdutosOnPosicao(selectedTp, state.selectedEstoque.id)
        break

      case LOAD_MESSAGE.POSICOES:
        dispatch(showLoadingBox('Aguarde...', state.loadingMessage))
        localDispatch.getPosicoesEstoqueRelatorioInventario(
          selectedTp,
          state.selectedEstoque.id,
          state.periodo.pInicial,
          state.periodo.pFinal,
        )
        break

      default:
        break
    }
  }, [state.loadingMessage])

  useEffect(() => {
    if (state.errorMessage) {
      dispatch(showMessageBox(null, state.errorMessage))
      localDispatch.resetState()
    }
  }, [state.errorMessage])

  return (
    <div>
      <PageHeader>8.12 - Relatório de Inventario por Posição</PageHeader>
      <div style={{ marginTop: 20 }}>
        <CustomPanel onNovo={() => {}} showBtnNovo={false} onVoltar={history.goBack}>
          <div className="p-grid">
            <div className="p-col-3">
              <CustomDropdown
                disabled={!selectedTp}
                placeholder="Selecione um Estoque"
                optionLabel={'name'}
                options={state.estoques}
                label={'Estoque'}
                onChange={value => localDispatch.onChange('selectedEstoque', value)}
                value={state.selectedEstoque}
              />
            </div>
            <div className="p-col-6 p-md-4">
              <Periodo
                btnEnabled={selectedTp}
                periodoInicial={state.periodo.dataInicial}
                periodoFinal={state.periodo.dataFinal}
                onPesquisar={(pInicial, pFinal) =>
                  localDispatch.onSearchRelatorioPosicoes(pInicial, pFinal, state.selectedEstoque)
                }
              />
            </div>
          </div>
          <div className="p-grid" style={{ marginBottom: 20 }}>
            <div className="p-col-3 p-mt-4">
              <CustomCard
                title="Posições Não Inventariadas"
                subTitle="Qte Posições Não Inventariadas"
              >
                {state.qtePosicoesNaoInventariadas}
              </CustomCard>
            </div>
            <div className="p-col-3 p-mt-4">
              <CustomCard title="Posições Inventariadas" subTitle="Qte Posições Inventariadas">
                {state.qtePosicoesInventariadas}
              </CustomCard>
            </div>
            <div className="p-col-4 p-mt-4">
              <CustomCard
                title="Percentual de Posições Inventariadas"
                subTitle="Percentual de posições inventariadas no periodo"
              >
                {state.percentualPosInventariadas}
              </CustomCard>
            </div>
          </div>
          <div className="p-grid">
            <div className="p-col-3">
              <CustomCheckbox
                disabled={!selectedTp}
                checked={state.showSomenteComInventario}
                onChange={value => localDispatch.onChange('showSomenteComInventario', value)}
              >
                Mostrar somente posições com inventario
              </CustomCheckbox>
            </div>
            <div className="p-col-3">
              <CustomCheckbox
                disabled={!selectedTp}
                checked={state.showSomenteSemInventario}
                onChange={value => localDispatch.onChange('showSomenteSemInventario', value)}
              >
                Mostrar somente posições sem inventario
              </CustomCheckbox>
            </div>
          </div>
          <div className="p-col-12">
            <DataTable
              value={
                state.showSomenteComInventario
                  ? state.posicoes.filter(p => p.inventario_name)
                  : state.showSomenteSemInventario
                    ? state.posicoes.filter(p => !p.inventario_name)
                    : state.posicoes
              }
              header={
                <CustomDataTableHeader
                  onChange={value => localDispatch.onChange('globalFilter', value)}
                >
                  <div style={{ textAlign: 'left', display: 'inline-block', marginLeft: 15 }}>
                    <Button
                      type="button"
                      icon="pi pi-external-link"
                      iconPos="left"
                      label="CSV"
                      onClick={onExport}
                    ></Button>
                  </div>
                </CustomDataTableHeader>
              }
              globalFilter={state.globalFilter}
              paginator={true}
              rows={10}
              ref={dt}
              emptyMessage="Nenhuma posição a ser exibida"
            >
              <Column field="endereco" header="Endereço" style={tableCellCentered(100)} />
              <Column field="inventario_name" header="Inventário" style={tableCellCentered(200)} />
              <Column
                filter={true}
                filterElement={statusFilter}
                field="status"
                header="Status"
                style={tableCellCentered(100)}
              />
              <Column field="created_at" header="Criado em" style={tableCellCentered(100)} />
              <Column field="finished_at" header="Finalizado em" style={tableCellCentered(80)} />
              <Column field="company_name" header="Empresa" style={tableCellCentered(100)} />
            </DataTable>
          </div>
        </CustomPanel>
      </div>
    </div>
  )
}

const mapStateToProps = ({ system: { selectedTp } }) => ({ selectedTp })
export default connect(mapStateToProps)(withRouter(RelatorioInventarioPosicao))
